import React from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import "./i18n";
import { App } from "./App";
import { ErrorBoundary, initMonitoring } from "./app/monitoring";

void initMonitoring();

// Service worker only for the browser/PWA build; Capacitor and Tauri serve the bundle locally and update it themselves.
if (!("Capacitor" in window) && !("__TAURI_INTERNALS__" in window) && "serviceWorker" in navigator) {
  void import("virtual:pwa-register").then(({ registerSW }) => registerSW({ immediate: true }));
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
